import React from 'react';

import {Slider} from "@mui/joy";


// components
import BaseApi from "../../utils/BaseApi";
import UserSubscriberContext from "../../context/UserSubscriberContext";


class TaskDuration extends React.Component {
    static contextType = UserSubscriberContext

    constructor(props) {
        super(props);
        this.state = {
            task: this.props.task
        };
    }

    async handleSlider(event, newValue){
        const api = new BaseApi();
        const url = `task/${this.props.task.id}/`;
        let response = await api.patch(
            url,
            {
                complete: newValue
            }
        );
        let task = response.data;
        task.executor = {
            id: task.executor
        }
        this.setState(
            {
                task: task
            }
        );
    }

    render() {
        return(
            <Slider
                disabled={
                    ['COM', 'DEL', 'CLD', 'DCL'].includes(this.state.task.work_status) ||
                    this.state.task.executor.id !== this.context.userObject.id
                }
                defaultValue={this.state.task.complete}
                max={100}
                valueLabelDisplay="on"
                marks
                step={1}
                onChange={this.handleSlider.bind(this)}
            />

        )
    }
}

export default TaskDuration